import { Link } from 'react-router-dom';
import { usePageMetadata } from '../hooks/usePageMetadata';

const posts = [
  {
    slug: 'dating-photo-mistakes',
    title: '7 Dating App Photo Mistakes That Kill Your Match Rate',
    excerpt: 'Most dating profiles fail because of 2-3 easily fixable photo mistakes, not because of how you look. Here are the 7 most common ones and how to fix each.',
    date: 'April 1, 2026',
    readTime: '6 min read',
    category: 'Dating',
    image: 'https://images.unsplash.com/photo-1516726817505-f5ed825624d8?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'how-to-choose-dating-photos',
    title: 'How to Choose Between Dating Photos When You Can\'t Decide',
    excerpt: 'You can\'t choose your best dating photo because you\'re too familiar with your own face. That\'s normal — and there\'s a fix.',
    date: 'March 31, 2026',
    readTime: '5 min read',
    category: 'Dating',
    image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'linkedin-photo-mistakes',
    title: '5 LinkedIn Photo Mistakes That Make Recruiters Skip Your Profile',
    excerpt: '67% of recruiters won\'t message you if your LinkedIn photo looks unprofessional. Here are the 5 most common mistakes and exactly how to fix each one.',
    date: 'March 30, 2026',
    readTime: '5 min read',
    category: 'LinkedIn',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'should-you-smile-linkedin-photo',
    title: 'Should You Smile in Your LinkedIn Photo? The Data Says Yes — With a Caveat',
    excerpt: 'Yes, you should smile in your LinkedIn photo. A natural, slight smile projects approachability and trust without undermining authority.',
    date: 'March 29, 2026',
    readTime: '4 min read',
    category: 'LinkedIn',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'dating-photos-for-men',
    title: 'Best Dating App Photos for Men: The Data-Backed Playbook',
    excerpt: 'Research from 1 million dating photos reveals exactly which types of pictures get the most swipes right. The data is surprisingly specific.',
    date: 'March 19, 2026',
    readTime: '7 min read',
    category: 'Dating',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'linkedin-photo-vs-headshot',
    title: "LinkedIn Photo vs Headshot: What's the Difference and Which Do You Need?",
    excerpt: "The terms get used interchangeably, but they signal very different things to recruiters. Here's how to pick the right one.",
    date: 'March 18, 2026',
    readTime: '5 min read',
    category: 'LinkedIn',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'better-selfies-dating-apps',
    title: 'How to Take Better Selfies for Dating Apps (Without a Photographer)',
    excerpt: "You don't need a DSLR or a friend with good timing. Five techniques that work with just your phone and a window.",
    date: 'March 17, 2026',
    readTime: '6 min read',
    category: 'Dating',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'photo-order-dating-apps',
    title: 'Photo Order on Dating Apps: Why Your Second Photo Matters More Than You Think',
    excerpt: 'Your lead photo gets the swipe. But your second photo gets the message. Here\'s how to sequence a lineup that converts.',
    date: 'March 16, 2026',
    readTime: '5 min read',
    category: 'Dating',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=500&fit=crop&q=80',
  },
  {
    slug: 'dating-photos-that-get-matches',
    title: 'The 5-Photo Formula That Gets 3x More Dating Matches',
    excerpt: 'Research from 1 million dating photos reveals exactly which types of pictures get the most swipes right. The data is surprisingly specific.',
    date: 'March 15, 2026',
    readTime: '6 min read',
    category: 'Dating',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop&q=80',
  },
  {
    slug: 'linkedin-headshot-guide',
    title: 'What Recruiters Actually See When They Look at Your LinkedIn Photo',
    excerpt: 'An eye-tracking study of 30 recruiters shows they spend 19% of their time on your photo. 67% won\'t message you if it looks unprofessional.',
    date: 'March 14, 2026',
    readTime: '5 min read',
    category: 'LinkedIn',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop&q=80',
  },
  {
    slug: 'instagram-photos-that-perform',
    title: 'Why Your Instagram Photos Get Ignored (And How to Fix It)',
    excerpt: 'The average engagement rate dropped to 2.3% in 2026. But the top 10% of posts share one thing in common — and it\'s not filters.',
    date: 'March 13, 2026',
    readTime: '7 min read',
    category: 'Social',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&h=400&fit=crop&q=80',
  },
];

export function Blog() {
  usePageMetadata({
    title: 'PhotoFeeler AI Blog — Dating and LinkedIn Photo Guides',
    description:
      'Practical guides for choosing better dating photos, stronger LinkedIn headshots, and improving profile-first impressions.',
    canonicalPath: '/blog',
  });
  return (
    <div className="relative overflow-hidden pt-24 pb-16 px-5 sm:px-8 max-w-5xl mx-auto animate-fade-in">
      <div className="page-orb left-[-5rem] top-24 h-72 w-72 bg-rose/15" />
      <div className="page-orb right-[-6rem] top-28 h-80 w-80 bg-info/10" />

      <div className="page-hero-panel text-center mb-14">
        <p className="premium-kicker mb-4">The PhotoFeeler Blog</p>
        <h1 className="font-serif text-4xl sm:text-6xl text-ink mb-4" style={{ fontWeight: 600, letterSpacing: '-0.03em' }}>
          Look better online.
        </h1>
        <p className="hero-copy max-w-2xl mx-auto">
          Research-backed insights on photo selection for Dating, LinkedIn, and the broader first-impression loop.
        </p>
        <div className="grid sm:grid-cols-3 gap-3 mt-6">
          <div className="premium-stat">
            <div className="text-sm font-sans text-ink" style={{ fontWeight: 600 }}>Dating</div>
            <div className="text-xs text-ink-faint mt-1">Lead-photo and lineup strategy</div>
          </div>
          <div className="premium-stat">
            <div className="text-sm font-sans text-ink" style={{ fontWeight: 600 }}>LinkedIn</div>
            <div className="text-xs text-ink-faint mt-1">Headshots and professional polish</div>
          </div>
          <div className="premium-stat">
            <div className="text-sm font-sans text-ink" style={{ fontWeight: 600 }}>Practical</div>
            <div className="text-xs text-ink-faint mt-1">Short reads with immediate next steps</div>
          </div>
        </div>
      </div>

      <div className="space-y-12">
        {posts.map((post, i) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="group block">
            <article className={`grid md:grid-cols-2 gap-8 items-center marketing-panel p-5 sm:p-6 lift-hover ${i % 2 === 1 ? 'md:direction-rtl' : ''}`}>
              <div className={`overflow-hidden rounded-[28px] ${i % 2 === 1 ? 'md:order-2' : ''}`}>
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-60 object-cover group-hover:scale-[1.03] transition-transform duration-700"
                />
              </div>
              <div className={i % 2 === 1 ? 'md:order-1' : ''}>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[10px] font-sans font-medium text-rose tracking-widest uppercase">{post.category}</span>
                  <span className="text-[10px] text-ink-faint">·</span>
                  <span className="text-[10px] text-ink-faint font-sans">{post.readTime}</span>
                </div>
                <h2 className="font-serif text-3xl text-ink mb-3 group-hover:text-rose transition-colors duration-300" style={{ fontWeight: 600 }}>
                  {post.title}
                </h2>
                <p className="text-sm text-ink-faint leading-relaxed mb-4" style={{ fontWeight: 300 }}>
                  {post.excerpt}
                </p>
                <span className="text-xs font-sans font-medium text-rose group-hover:underline">Read more →</span>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
}
